// Centralized data-testid constants
export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  bookNowBtn: "nav-book-now-btn",
};

export const HERO = {
  section: "hero-section",
  heading: "hero-heading",
  ctaBook: "hero-cta-book",
  ctaCall: "hero-cta-call",
};

export const FEATURES = {
  section: "features-section",
  card: (key) => `feature-card-${key}`,
};

export const BOOKING = {
  section: "booking-section",
  binsSelect: "booking-bins-select",
  binsIncrement: "booking-bins-increment",
  binsDecrement: "booking-bins-decrement",
  binsValue: "booking-bins-value",
  citySelect: "booking-city-select",
  calendar: "booking-calendar",
  slotsGrid: "booking-slots-grid",
  slotBtn: (time) => `booking-slot-${time}`,
  nameInput: "booking-name-input",
  emailInput: "booking-email-input",
  phoneInput: "booking-phone-input",
  addressInput: "booking-address-input",
  notesInput: "booking-notes-input",
  paymentStripe: "booking-payment-stripe",
  paymentCash: "booking-payment-cash",
  submitBtn: "booking-submit-btn",
  totalAmount: "booking-total-amount",
  durationLabel: "booking-duration-label",
  recurrenceBtn: (key) => `booking-recurrence-${key}`,
  occurrencesInput: "booking-occurrences-input",
};

export const ABOUT = {
  section: "about-section",
};

export const FOOTER = {
  section: "footer-section",
  callLink: "footer-call-link",
  textLink: "footer-text-link",
};
